import { render, staticRenderFns } from "./frameChoose.vue?vue&type=template&id=54e06ad5&scoped=true&"
import script from "./frameChoose.vue?vue&type=script&lang=js&"
export * from "./frameChoose.vue?vue&type=script&lang=js&"
import style0 from "./frameChoose.vue?vue&type=style&index=0&id=54e06ad5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e06ad5",
  null
  
)

export default component.exports